<div class="fpui-tab-wrapper" v-if="active"><div class="fpui-tab-content"><slot></slot></div></div>